export default import.meta.ROLLUP_FILE_URL_y37aoKUoBDAXBywY38_A2Q